// document.addEventListener("DOMContentLoaded", function() {
//     document.querySelector(".add-cart-button").addEventListener("click", function(event) {
//         event.preventDefault();
//         let form = event.target.closest("form");
//         let formData = new FormData(form);
//         fetch('/cart/add', {
//             method: 'POST',
//             body: formData
//         }).then(() => {
//             window.location.href = '/checkout';
//         });
//     });
// });
document.querySelectorAll('.mobile-menu-content .level0 a[href], .mobile-menu-content .level-1 a[href]').forEach(link => {
  const href = link.getAttribute('href');
  if (href && href !== '#' && window.location.pathname === href) {
    // Add active to the link itself
    link.classList.add('active');
    // Add active to the parent li
    link.closest('li').classList.add('active');
    // If inside a submenu, also mark parent level0 as active
    const parentLevel0 = link.closest('.level0');
    if (parentLevel0) parentLevel0.classList.add('active');
  }
});